/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FormBusinessTypeField_viewer$ref = any;
type FormJobCategoryTypeField_viewer$ref = any;
type FormSubdivisionField_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CustomerInfoForm_viewer$ref: FragmentReference;
declare export opaque type CustomerInfoForm_viewer$fragmentType: CustomerInfoForm_viewer$ref;
export type CustomerInfoForm_viewer = {|
  +user: ?{|
    +firstName: ?string,
    +lastName: ?string,
    +phoneNumber: ?string,
    +companyName: ?string,
    +officeName: ?string,
    +departmentName: ?string,
    +businessType: ?string,
    +jobCategoryType: ?string,
    +subdivisionCode: ?string,
  |},
  +$fragmentRefs: FormBusinessTypeField_viewer$ref & FormSubdivisionField_viewer$ref & FormJobCategoryTypeField_viewer$ref,
  +$refType: CustomerInfoForm_viewer$ref,
|};
export type CustomerInfoForm_viewer$data = CustomerInfoForm_viewer;
export type CustomerInfoForm_viewer$key = {
  +$data?: CustomerInfoForm_viewer$data,
  +$fragmentRefs: CustomerInfoForm_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CustomerInfoForm_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "firstName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "lastName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "phoneNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "companyName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "officeName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "departmentName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "businessType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "jobCategoryType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "subdivisionCode",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "FormBusinessTypeField_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FormSubdivisionField_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FormJobCategoryTypeField_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '08899fcec80c4ba1c31f43cd5b7169c0';
module.exports = node;
